{
  "help": "Ohje",
  "info": "Tiedot"
}
